module.exports = __webpack_public_path__ + "static/media/MobileBackground.f13e0da0.jpg";